import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { SectionHeading } from 'site-modules/shared/components/editorial/section-heading/section-heading';
import { CalculatorForm } from './calculator-form/calculator-form';

import './calculators.scss';

const SUBTEXT_CAR_LOAN = 'Calculate your car payment for a basic car loan';
const SUBTEXT_CAR_LEASE = 'Calculate your car payment for a lease';
const SUBTEXT_AFFORDABILITY = 'Calculate your ideal price range for buying a car';
const AFFORDABILITY_URL = '/calculators/affordability.html';
const LEASE_URL = '/calculators/car-lease.html';
const SIMPLIFIED_PRICING_URL = '/calculators/simplified-pricing.html';
const TOOL_SELECT_SELECT = 'tool_select_select';
const TOOL_SELECT_VIEW = 'tool_select_view';

const TRACKING_LOAN = {
  toolSelectShow: 'tool_select_show_loan',
  toolSelectInput: 'tool_select_input_monthly',
};
const TRACKING_LEASE = {
  toolSelectShow: 'tool_select_show_lease',
  toolSelectInput: 'tool_select_input_vehicle',
};
const TRACKING_AFFORDABILITY = {
  toolSelectShow: 'tool_select_show_affordability',
  toolSelectInput: 'tool_select_input_vehicle',
};

function SelectVehicle({ link, tracking }) {
  return (
    <span className="small">
      or
      <a
        href={`${link}?sv`}
        className="text-uppercase fw-bold ps-0_5 pe-0_25"
        data-tracking-id={tracking}
        rel="nofollow"
      >
        Select a vehicle
      </a>
      <i className="text-gray-darker icon-arrow-right3" aria-hidden />
    </span>
  );
}

SelectVehicle.propTypes = {
  link: PropTypes.string.isRequired,
  tracking: PropTypes.string.isRequired,
};

function CalculatorBox({ children, className, header }) {
  return (
    <div className={classnames('calculator-box', className)}>
      <h3 className="text-gray-darker mb-0_25 h5">{header}</h3>
      {children}
    </div>
  );
}

CalculatorBox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  header: PropTypes.string,
};

CalculatorBox.defaultProps = {
  children: null,
  className: 'p-1',
  header: '',
};

export function Calculators({ calculatorBoxClassName, hasHeading }) {
  return (
    <div className="calculators">
      {hasHeading && (
        <SectionHeading
          linkout={{ href: '/calculators/', tracking: { id: TOOL_SELECT_VIEW } }}
          linkoutText="View all calculators"
        >
          Calculators
        </SectionHeading>
      )}
      <Row>
        <Col xs={12} md={4}>
          <CalculatorBox className={calculatorBoxClassName} header="Car Loan Calculator">
            <p className="h6 fw-normal calc-description">{SUBTEXT_CAR_LOAN}</p>
            <div>
              <CalculatorForm action={SIMPLIFIED_PRICING_URL} tracking={TRACKING_LOAN}>
                Enter preffered monthly payment
              </CalculatorForm>
              <SelectVehicle link={SIMPLIFIED_PRICING_URL} tracking={TOOL_SELECT_SELECT} />
            </div>
          </CalculatorBox>
        </Col>
        <Col xs={12} md={4}>
          <CalculatorBox className={calculatorBoxClassName} header="Car Lease Calculator">
            <p className="h6 fw-normal calc-description">{SUBTEXT_CAR_LEASE}</p>
            <div>
              <CalculatorForm action={LEASE_URL} tracking={TRACKING_LEASE}>
                Enter a vehicle price
              </CalculatorForm>
              <SelectVehicle link={LEASE_URL} tracking={TOOL_SELECT_SELECT} />
            </div>
          </CalculatorBox>
        </Col>
        <Col xs={12} md={4}>
          <CalculatorBox className={calculatorBoxClassName} header="Affordability Calculator">
            <p className="h6 fw-normal calc-description">{SUBTEXT_AFFORDABILITY}</p>
            <div>
              <CalculatorForm action={AFFORDABILITY_URL} tracking={TRACKING_AFFORDABILITY}>
                Enter a vehicle price
              </CalculatorForm>
            </div>
          </CalculatorBox>
        </Col>
      </Row>
    </div>
  );
}

Calculators.propTypes = {
  calculatorBoxClassName: PropTypes.string,
  hasHeading: PropTypes.bool,
};

Calculators.defaultProps = {
  calculatorBoxClassName: 'p-1',
  hasHeading: true,
};
